import { render, staticRenderFns } from "./SalesFlyerLightboxViewDesktop.vue?vue&type=template&id=1ced2e6e"
import script from "./SalesFlyerLightboxViewDesktop.vue?vue&type=script&setup=true&lang=ts"
export * from "./SalesFlyerLightboxViewDesktop.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./SalesFlyerLightboxViewDesktop.vue?vue&type=style&index=0&id=1ced2e6e&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports